<script setup>
import { computed } from 'vue';
import IconInfo from '@components/OfferCard/icons/IconInfo.vue';
import { trans, transchoice } from '@tools/translation';

const props = defineProps({
  firstOffer: {
    type: Object,
    required: true,
  },
  offers: {
    type: Array,
    default: () => [],
  },
  isOwnerView: {
    type: Boolean,
    required: true,
  },
});

const isMultiOffice = computed(() => props.offers.length > 1);

const displayType = computed(() => {
  if (isMultiOffice.value) {
    return trans('offer_card.display_types.multioffice', { count: props.offers.length });
  }

  return props.isOwnerView ? props.firstOffer.office_type?.name ?? props.firstOffer.type_infos : props.firstOffer.type_infos;
});
</script>

<template>
  <div class="offer-card__container-type">
    <p class="offer-card__container-type__text">
      {{ displayType }}
    </p>

    <div
      v-if="isMultiOffice"
      class="tooltip"
    >
      <IconInfo />

      <div class="tooltiptext tooltip__panel">
        <b>{{ trans('offer_card.tooltip.multioffice', { count: offers.length }) }}</b>
        <ul>
          <li
            v-for="offer in offers"
            :key="offer.hash_id"
            class="whitespace-nowrap"
          >
            • {{ trans(`office_type.${offer.office_type.code}`) }}

            • {{ offer.capacity }} {{ transchoice('multioffice.capacity', { count: offer.capacity }) }}

            <template v-if="offer.surface">
              • {{ offer.surface }} {{ trans('global.area_unit.MTK') }}
            </template>
          </li>
        </ul>
      </div>
    </div>

    <div
      v-else-if="firstOffer.is_flex_operator_display_type"
      class="tooltip"
    >
      <IconInfo />

      <span class="tooltiptext tooltip__panel">
        {{ trans('offer_card.tooltip.flex_operator') }}
      </span>
    </div>
  </div>
</template>
